<template>
  <main>
    <div class="path">
      <i class="el-icon-caret-right"></i>订单中心
      <i class="el-icon-arrow-right"></i>&nbsp;订单列表
    </div>

    <section v-if="orderList.length" class="merchant_container">
      <div class="merchant_wrapper">
        <div class="order_title">订单列表</div>
        <hr>
        <div v-for="(item, index) in orderList" :key="index" class="merchant_block">
          <div class="merchant_content">

            <img class="storefront_image" :src="item.course.coverPic" @click="playCourse(item)">
            <div class="merchant_desc">
              <div class="merchant_desc">
                <div style="cursor: pointer;" @click="playCourse(item)">购买课程：{{item.course.name}}</div>
                <div>订单编号：{{item.orderNo}}</div>
                <div>下单时间：{{item.createTime}}</div>
                <div>支付状态：{{item.payStatus === 1 ? '已支付' : item.payStatus === 0 ? '未支付' : '支付异常'}}</div>
                <div>实付金额：￥{{item.realPrice}}</div>
                <div v-if="item.payStatus === 1">支付时间：{{item.payedTime}}</div>
                <div v-if="item.invoiceStatus === 0">
                  <el-link type="primary" @click="getInvoiceInfo(item)">申请开发票</el-link>
                </div>
                <div v-else>
                  <div style="font-size: 14px; line-height: 30px; color: #999;" v-if="item.invoiceStatus === 1">已申请开发票, 申请时间{{item.invoiceTime}}</div>
                  <div style="font-size: 14px; line-height: 30px; color: #999;" v-if="item.invoiceStatus === 9">开发已票</div>
                </div>

              </div>
            </div>
          </div>
          <hr>
        </div>
      </div>

      <el-dialog title="发票信息" :visible.sync="dialogFormVisible">
        <el-form ref="form" :model="form" :rules="rules">
          <el-form-item label="个人/企业名称" :label-width="formLabelWidth" prop="name">
            <el-input v-model="form.name" placeholder="请填写发票名称" required></el-input>
          </el-form-item>
          <el-form-item label="纳税人识别号" :label-width="formLabelWidth">
            <el-input v-model="form.txNo"></el-input>
          </el-form-item>
          <el-form-item label="单位地址" :label-width="formLabelWidth">
            <el-input v-model="form.address"></el-input>
          </el-form-item>
          <el-form-item label="开户银行" :label-width="formLabelWidth">
            <el-input v-model="form.bankName"></el-input>
          </el-form-item>
          <el-form-item label="银行账户" :label-width="formLabelWidth">
            <el-input v-model="form.bankAccount"></el-input>
          </el-form-item>
          <el-form-item label="单位电话" :label-width="formLabelWidth">
            <el-input v-model="form.telePhone"></el-input>
          </el-form-item>
          <el-form-item label="消费金额" :label-width="formLabelWidth">
            <el-input v-model="form.price" disabled></el-input>
          </el-form-item>
          <el-form-item label="电子邮箱" :label-width="formLabelWidth" prop="email">
            <el-input v-model="form.email" required placeholder="请填写邮箱地址，用于接收电子发票"></el-input>
          </el-form-item>
          <el-form-item label="备注" :label-width="formLabelWidth">
            <el-input v-model="form.note"></el-input>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="invoice">确 定</el-button>
        </div>
      </el-dialog>

    </section>
    <div class="no_data_tip" v-else>
      无订单数据
    </div>
  </main>
</template>

<script>
import {mapState, mapGetters} from 'vuex'
import {
  reqFindCustomerOrders,
  reqInvoice,
  reqGetInvoiceInfo
} from '@/api'

export default {
  name: 'OrderList',

  data() {
    return {
      orderList: [], // 订单列表
      dialogFormVisible: false,
      order: {},
      formData: '',
      form: {
        name: '',
        txNo: '',
        address: '',
        price: 0,
        bankName: '',
        bankAccount: '',
        telePhone: '',
        email: '',
        note: '', // 备注
      },
      formLabelWidth: '120px',
      rules: {
        name: [
          { required: true, message: '请填写发票名称', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请填写电子邮箱', trigger: 'blur' }
        ]
      },
    }
  },

  async mounted () {
    if (!this.isLogin) {
      this.$router.push('/')
      return
    }

    const loading = this.$loading({
      lock: true,
      text: '加载中',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
    // const phone = this.phone
    const result = await reqFindCustomerOrders()
    if (result.code === 0) {
      this.orderList = result.data
    }
    loading.close()
  },

  methods: {

    async getInvoiceInfo (order) {
      this.order = order
      this.dialogFormVisible = true
      this.form.price = order.realPrice
      const result = await reqGetInvoiceInfo()
      if (result.code === 0) {
        this.form.email = result.data.email
        if (result.data.id) {
          this.form.name = result.data.name
          this.form.address = result.data.address
          this.form.txNo = result.data.txNo
          this.form.telePhone = result.data.telePhone
          this.form.bankName = result.data.bankName
          this.form.bankAccount = result.data.bankAccount
        }
      }
    },

    invoice () {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (!this.rightEmail) {
            await this.$alert('邮箱地址不正确', '错误', {
              confirmButtonText: '确定',
              callback: action => {
              }
            })
            return
          }

          this.formData = new FormData()
          let config = {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
          this.formData.append('address', this.form.address.trim())
          this.formData.append('name', this.form.name.trim())
          this.formData.append('txNo', this.form.txNo.trim())
          this.formData.append('bankName', this.form.bankName.trim())
          this.formData.append('bankAccount', this.form.bankAccount.trim())
          this.formData.append('telePhone', this.form.telePhone.trim())
          this.formData.append('email', this.form.email.trim())
          this.formData.append('note', this.form.note.trim())
          this.formData.append('price', this.form.price)
          this.formData.append('orderId', this.order.id)

          const loading = this.$loading({
            lock: true,
            text: '提交中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })

          const result = await reqInvoice(this.formData, config)

          loading.close()

          if (result.code === 0) {
            this.$refs.form.resetFields()
            this.dialogFormVisible = false
            this.$message({
              message: '发票申请提交成功，待税务系统出具发票后会发送到预留的电子邮箱',
              type: 'success'
            })
          }
        } else {
          await this.$alert('输入信息不正确，请完善后再提交！', '提示', {
            confirmButtonText: '确定',
            callback: action => {
            }
          })
          return false
        }
      })
    },

    playCourse (order) {
      const videoNo = order.no * 1000 + 1
      this.$router.push({
        path: '/playCourse',
        query: {no: order.no, videoNo: videoNo}
      }).catch(err=>{})
    },

  },

  computed: {
    ...mapState(['phone']),
    ...mapGetters(['isLogin']),
    rightEmail () {
      if (!this.form.email || this.form.email.length > 32)
        return false

      return /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/.test(this.form.email)
    },
  }
}
</script>

<style scoped>

  main {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
  }

  .path {
    height: 40px;
    line-height: 40px;
    padding-left: 16px;
    font-size: 14px;
    color: #666;
  }

  .merchant_container {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .merchant_wrapper {
    width: 900px;
    margin: 10px auto;
    background: #fff;
    display: flex;
    flex-direction: column;
    padding: 0 20px;
    position: relative;
  }

  .merchant_name {
    cursor: pointer;
  }

  .order_title {
    /*line-height: 40px;*/
    margin-top: 20px;
    font-size: 16px;
    font-weight: 500;
  }

  hr {
    border: 1px solid #eee;
    width: 100%;
    margin: 20px 0;
  }

  .merchant_content {
    display: flex;
  }

  .storefront_image {
    width: 250px;
    height: 180px;
    border-radius: 6px;
    margin-right: 20px;
    cursor: pointer;
    border: 1px solid;
  }

  .merchant_desc {
    display: flex;
    flex-direction: column;
  }

  .merchant_desc div:first-child {
    font-size: 16px;
    color: #000;
    font-weight: bold;
  }

  .merchant_desc div {
    line-height: 30px;
    font-size: 14px;
    color: #999;
  }

  .search_button {
    margin-left: 30px;
    height: 40px;
  }

  .price_wrapper {
    display: flex;
  }

  .price_wrapper div:first-child {
    font-size: 24px;
    color: #FF6666;
    margin-right: 14px;
  }

  .no_data_tip {
    display: flex;
    width: 100%;
    justify-content: center;
    font-size: 14px;
    color: #666;
    line-height: 40px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/CustomerCenter/OrderList/OrderList.vue